<app-topbar></app-topbar>
<div class="content-container">
  <app-navbar></app-navbar>
  <div class="container-fluid">
    <h2 class="my-3">Subir Archivos</h2>
    <div class="mb-3">
      <label for="obraSocial" class="form-label">Obra Social</label>
      <select
        class="form-control custom-select"
        id="obraSocial"
        [(ngModel)]="obraSocialSeleccionada"
        (change)="onObraSocialChange()"
      >
        <option value="" disabled>Seleccione una obra social</option>
        <option
          *ngFor="let obraSocial of obrasSociales"
          [value]="obraSocial.id"
        >
          {{ obraSocial.descripcion }}
        </option>
      </select>
    </div>

    <table class="table mt-3">
      <thead>
        <tr>
          <th>Tipo de Archivo</th>
          <th>Nombre del Archivo</th>
          <th>Seleccionar Archivo</th>
          <th>Acción</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let tipo of tiposArchivo; let i = index">
          <td>{{ tipo }}</td>
          <td>{{ archivosSeleccionados[i] }}</td>
          <td>
            <!-- Input de archivo oculto -->
            <input
              class="form-control d-none"
              type="file"
              id="formFile-{{ i }}"
              (change)="seleccionarArchivo($event, i)"
            />

            <!-- Contenedor flex adaptable -->
            <div class="d-flex flex-column flex-md-row align-items-start gap-2">
              <!-- Botón siempre visible -->
              <button
                class="btn btn-primary mb-2 mb-md-0"
                (click)="triggerFileInput(i)"
              >
                Seleccionar archivo
              </button>

              <!-- Selectores y período condicionales -->
              <div
                *ngIf="requiereSelectorPeriodoParaTipo(tipo)"
                class="d-flex flex-column"
              >
                <div class="input-group mb-1">
                  <select
                    class="form-control"
                    [(ngModel)]="mesSeleccionado[i]"
                    [ngModelOptions]="{ standalone: true }"
                    [disabled]="!hayArchivoAportesSeleccionado()"
                  >
                    <option [ngValue]="null" disabled>Mes</option>
                    <option
                      *ngFor="let opcionMes of getMesesDisponiblesParaIndice(i)"
                      [value]="opcionMes.valor"
                    >
                      {{ opcionMes.texto }}
                    </option>
                  </select>
                  <select
                    class="form-select"
                    [(ngModel)]="anioSeleccionado[i]"
                    [ngModelOptions]="{ standalone: true }"
                    (change)="onAnioChange(i)"
                    [disabled]="!hayArchivoAportesSeleccionado()"
                  >
                    <option [ngValue]="null" disabled>Año</option>
                    <option
                      *ngFor="let anio of aniosDisponibles"
                      [ngValue]="anio"
                    >
                      {{ anio }}
                    </option>
                  </select>
                </div>
                <small class="text-muted"
                  >Período Percibido: {{ obtenerPeriodoFormateado(i) }}</small
                >
              </div>
            </div>
          </td>
          <td>
            <button
              *ngIf="archivosSeleccionados[i] !== 'Seleccione un Archivo'"
              class="btn btn-danger"
              (click)="eliminarArchivo(i)"
            >
              Eliminar
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <p class="text-danger" style="font-size: 0.9em">
      Por favor, seleccione correctamente los archivos para el proceso. Una vez
      comenzado, no se puede volver atrás y tiene efecto inmediato, afectando
      los datos del padrón.
    </p>
    <button
      class="btn btn-success"
      (click)="subirArchivos()"
      *ngIf="hayArchivosSeleccionados()"
    >
      Subir Archivos
    </button>
  </div>
</div>
